var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpRightFromSquareRegularFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1092px",
    height: "1080px",
    viewBox: "0 0 1092 1080",
    enableBackground: "new 0 0 1092 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M600,148.5c0,22.444,18.057,40.5,40.5,40.5h199.294L449.981,578.813c-15.862,15.862-15.862,41.513,0,57.206 c15.862,15.694,41.513,15.862,57.206,0L897,246.206V445.5c0,22.443,18.057,40.5,40.5,40.5s40.5-18.057,40.5-40.5v-297 c0-22.444-18.057-40.5-40.5-40.5h-297C618.057,108,600,126.056,600,148.5z M249,270c-74.587,0-135,60.412-135,135v432 c0,74.588,60.413,135,135,135h432c74.588,0,135-60.412,135-135V688.5c0-22.443-18.057-40.5-40.5-40.5S735,666.057,735,688.5V837 c0,29.869-24.131,54-54,54H249c-29.869,0-54-24.131-54-54V405c0-29.869,24.131-54,54-54h148.5c22.444,0,40.5-18.057,40.5-40.5 c0-22.444-18.056-40.5-40.5-40.5H249z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRightFromSquareRegularFull);
export default __webpack_public_path__ + "static/media/arrow-up-right-from-square-regular-full.86f0a6ebdba3da4137216465cca89bc3.svg";
export { ForwardRef as ReactComponent };